import defaultTablesOptions from '../сonfig-and-helpers/default-tables-options';
import {
    commaDelimitedNumber,
    gridDateStringValueFormatter,
} from '../сonfig-and-helpers/helpers';

function gridOptions(classReference) {
    const defaultOptions = defaultTablesOptions(classReference);

    //
    const textFilterParams = {
        filterOptions: [
            // 'equals',
            // 'notEqual',
            'greaterThan',
            'greaterThanOrEqual',
            'lessThan',
            'lessThanOrEqual',
            'inRange',
            // 'blank',
            // 'notBlank',
            // 'empty',
        ],
    };

    return {
        ...defaultOptions,
        rowSelection: 'multiple',
        // enableAdvancedFilter: true,

        columnDefs: [
            {
                field: 'geo_type',
                headerName: 'Geo Type',
                cellDataType: 'text',
                filter: false,
                sortable: false,
                chartDataType: 'category',
                width: 180,
                minWidth: 180,
                headerCheckboxSelection: true,
                hide: true,
            },
            {
                field: 'data_market_name',
                headerName: 'Market Name',
                cellDataType: 'text',
                filter: false,
                sortable: false,
                chartDataType: 'category',
                width: 200,
                minWidth: 200,
                headerCheckboxSelection: true,
            },
            {
                field: 'period_frequency',
                headerName: 'Frequency',
                filter: false,
                sortable: false,
                cellDataType: 'text',
                chartDataType: 'category',
                width: 120,
                minWidth: 120,
                headerCheckboxSelection: true,
            },
            {
                field: 'year',
                headerName: 'Year',
                filter: false,
                sortable: false,
                cellDataType: 'number',
                chartDataType: 'category',
                width: 90,
                minWidth: 90,
                headerCheckboxSelection: true,
                hide: true,
            },
            {
                field: 'qtr_number',
                headerName: 'Quarter',
                filter: false,
                sortable: false,
                cellDataType: 'number',
                chartDataType: 'category',
                width: 90,
                minWidth: 90,
                headerCheckboxSelection: true,
                hide: true,
            },
            {
                field: 'begin_date',
                headerName: 'Period Date',
                filter: 'agDateColumnFilter',
                cellDataType: 'dateString',
                cellClass: 'DateString',
                sort: 'desc',
                sortable: true,
                chartDataType: 'category',
                width: 150,
                minWidth: 150,
                headerCheckboxSelection: true,
                valueFormatter: gridDateStringValueFormatter,
            },
            //
            {
                field: 'down_payment',
                headerName: 'Down Payment',
                valueFormatter: `parseFloat((value * 100).toFixed(3)).toString() + '%'`,
                filter: false,
                filterParams: textFilterParams,
                cellDataType: 'number',
                chartDataType: 'series',
                width: 90,
                minWidth: 90,
                headerCheckboxSelection: true,
            },
            {
                field: 'qualifying_ratio',
                headerName: 'Qualifying Ratio',
                valueFormatter: `parseFloat((value * 100).toFixed(3)).toString() + '%'`,
                filter: false,
                filterParams: textFilterParams,
                cellDataType: 'number',
                chartDataType: 'series',
                width: 90,
                minWidth: 90,
                headerCheckboxSelection: true,
            },
            {
                field: 'filter_text',
                headerName: 'Filter',
                filter: false,
                sortable: false,
                cellDataType: 'text',
                width: 210,
                minWidth: 210,
                headerCheckboxSelection: true,
                hide: true,
            },
            //
            {
                field: 'hai',
                headerName: 'HAI',
                filter: 'agNumberColumnFilter',
                filterParams: textFilterParams,
                cellDataType: 'number',
                chartDataType: 'series',
                width: 90,
                minWidth: 90,
                headerCheckboxSelection: true,
            },
            {
                field: 'hai_fthb',
                headerName: 'FTHB HAI',
                filter: 'agNumberColumnFilter',
                filterParams: textFilterParams,
                cellDataType: 'number',
                chartDataType: 'series',
                width: 90,
                minWidth: 90,
                headerCheckboxSelection: true,
            },
            //
            {
                field: 'median_close_price',
                headerName: 'Median Price',
                cellRenderer: commaDelimitedNumber,
                filter: 'agNumberColumnFilter',
                filterParams: textFilterParams,
                cellDataType: 'number',
                chartDataType: 'series',
                width: 100,
                minWidth: 100,
                headerCheckboxSelection: true,
                hide: true,
            },
            {
                field: 'median_income',
                headerName: 'Median Income',
                cellRenderer: commaDelimitedNumber,
                filter: 'agNumberColumnFilter',
                filterParams: textFilterParams,
                cellDataType: 'number',
                chartDataType: 'series',
                width: 100,
                minWidth: 100,
                headerCheckboxSelection: true,
                hide: true,
            },
            {
                field: 'required_income',
                headerName: 'Required Income',
                cellRenderer: commaDelimitedNumber,
                filter: 'agNumberColumnFilter',
                filterParams: textFilterParams,
                cellDataType: 'number',
                chartDataType: 'series',
                width: 100,
                minWidth: 100,
                headerCheckboxSelection: true,
                hide: true,
            },
            {
                field: 'avg_mortgage_rate',
                headerName: 'Avg Mortgage Rate',
                valueFormatter: `value.toString() + '%'`,
                filter: 'agNumberColumnFilter',
                filterParams: textFilterParams,
                cellDataType: 'number',
                chartDataType: 'series',
                width: 100,
                minWidth: 100,
                headerCheckboxSelection: true,
                hide: true,
            },
        ],
    };
}
export default gridOptions;
